export class JwtUtils {
  public static decodePayload<T extends Record<string, unknown> = Record<string, unknown>>(
    accessToken?: string | null
  ): T | null {
    if (!accessToken) {
      return null;
    }

    try {
      const [, payloadPart] = accessToken.split('.');

      if (!payloadPart) {
        return null;
      }

      return JSON.parse(JwtUtils.decodeBase64Url(payloadPart)) as T;
    } catch {
      return null;
    }
  }

  public static getEmail(accessToken?: string | null): string | null {
    const payload = JwtUtils.decodePayload<{ email?: string }>(accessToken);

    return payload?.email || null;
  }

  public static decodeBase64Url(value: string): string {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');

    return decodeURIComponent(
      atob(paddedBase64)
        .split('')
        .map(char => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );
  }
}
